/**
 * @generated SignedSource<<fc9bc9ff1cc37f57f57b21d06cf6e560>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
import { FragmentRefs } from "relay-runtime";
export type OtherPlayersInThisBooking_Booking$data = {
  readonly id: string;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly rounds: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly courseLayout: {
          readonly holeCount: HoleCount;
        } | null | undefined;
        readonly player: {
          readonly firstName: string | null | undefined;
          readonly fullName: string;
          readonly id: string;
          readonly lastName: string | null | undefined;
        } | null | undefined;
        readonly transportationType: {
          readonly code: TransportationCode | null | undefined;
          readonly customCode: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "OtherPlayersInThisBooking_Booking";
};
export type OtherPlayersInThisBooking_Booking$key = {
  readonly " $data"?: OtherPlayersInThisBooking_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"OtherPlayersInThisBooking_Booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OtherPlayersInThisBooking_Booking",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Customer",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "Member",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseLayout",
                  "kind": "LinkedField",
                  "name": "courseLayout",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "holeCount",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TransportationType",
                  "kind": "LinkedField",
                  "name": "transportationType",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "code",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "customCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "d578a62c88a1f929984403ff7537bb47";

export default node;
